import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import DataTable from "react-data-table-component";

import "./../assets/css/nucleo-icons.css";
import "./../assets/css/soft-ui-dashboard.css";
import "./../assets/css/nucleo-svg.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import CONSTANTS from "../util/constants";
import { useDispatch, useSelector } from "react-redux";
import InputComp from "./InputComp";
import DropDownComp from "./DropDownComp";
import Encrypt from "../util/encrypt";

const CorrectionComp = () => {
  const gridRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);

  const [newCorrectionClick, setNewCorrectionClick] = useState(true);
  const [showCorrectionLog, setShowCorrectionLog] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(false);
  const [customPlaceTrailer, setCustomPlaceTrailer] = useState(false);
  const [chooseTrailer, setChooseTrailer] = useState({});
  const [systemLocation, setsystemLocation] = useState("");
  const [divisionArr, setDivisionArr] = useState([]);
  const [incoorrect_door_id, setInCorrectDoorId] = useState(null);
  const [incoorrect_space_id, setInCorrectSpaceId] = useState(null);
  const [correctSpaceId, setCorrectSpaceId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [doorDataArr, setDoorDataArr] = useState([]);
  const [lotDataArray, setLotArray] = useState([]);
  const [spaceArr, setSpaceArray] = useState([]);
  const [locationArr, setLocationArray] = useState([]);
  const [location, setLocation] = useState([]);
  const [correctionLodData, setCorrectionLogData] = useState([]);
  const [division, setDivision] = useState("");
  const [door, setDoor] = useState("");
  const [lot, setChooseLot] = useState("");
  const [space, setSpace] = useState("");
  const [doorRadio, setDoorRadio] = useState(false);
  const [spaceRadio, setSpaceRadio] = useState(false);
  const [Offsite, setOffSiteRadio] = useState(false);
  const [rowDataSpace, setRowDataSpace] = useState([]);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  const rowDataSpaceTemp = useSelector((state) => state.lots.getSpaceByLotData);

  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );
  console.log("divisionSelectedTemp", divisionSelectedTemp);
  const rowDataDivision = useSelector(
    (state) => state.division.getDivisionData
  );

  const rowDataDoor = useSelector((state) => state.doors.getDoorForMove);

  const rowDataLot = useSelector((state) => state.lots.getLotDivisionData);

  const rowDataLocation = useSelector(
    (state) => state.location.getLocationData
  );

  const rowDataTrailer = useSelector(
    (state) => state.trailerManagement.getTrailerData
  );

  const rowDataDoorLogTemp = useSelector((state) => state.doors.getDoorLogs);

  const rowDataRuralLog = useSelector(
    (state) => state.ruralTrailer.getRuralTrailerLogsData
  );

  const rowDataSpaceLogTemp = useSelector(
    (state) => state.lots.getSpaceLogData
  );

  const addCorrectionLogResponse = useSelector(
    (state) => state.correction.addCorrectionSuccess
  );

  const rowDataCorrectionLog = useSelector(
    (state) => state.correction?.getCorrectionLogSuccess?.rows
  );

  const rowDataCorrectionLogCount = useSelector(
    (state) => state.correction.getCorrectionLogSuccess?.count
  );

  const [trailerIdArray, setTrailerIdArray] = useState([]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
        .GET_TRAILER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    if (userId != "" || userId != null) {
      let localstorageLR = localStorage.getItem("L_R");
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let userId = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.user_id
          : ""
        : "";

      setUserId(userId);
    }

    if (rowDataDivision && rowDataDivision?.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataDivision.length; i++) {
        if (
          rowDataDivision[i]?.is_active &&
          divisionSelectedTemp?.value === rowDataDivision[i]?.division_id
        ) {
          data.push({
            label: rowDataDivision[i].divisionName,
            value: rowDataDivision[i].division_id,
            division_id: rowDataDivision[i].division_id,
          });
        }
      }
      setDivisionArr(data);
    }

    if (rowDataLot && rowDataLot?.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataLot.length; i++) {
        if (rowDataLot[i]?.is_active === 1) {
          data.push({
            label: rowDataLot[i].lotName,
            value: rowDataLot[i].lot_id,
          });
        }
      }
      setLotArray(data);
    }

    if (rowDataDoor && rowDataDoor?.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataDoor.length; i++) {
        data.push({
          label: rowDataDoor[i].doorType + "_" + rowDataDoor[i].number,
          value: rowDataDoor[i].door_id,
          currentOccupancy: rowDataDoor[i].currentOccupancy,
        });
      }
      setDoorDataArr(data);
    }
  }, []);

  useEffect(() => {
    if (rowDataSpaceTemp && rowDataSpaceTemp?.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataSpaceTemp.length; i++) {
        data.push({
          label:
            division.label + "_" + lot.label + "_" + rowDataSpaceTemp[i].btId,
          value: rowDataSpaceTemp[i].space_id,
          currentOccupancy:
            rowDataSpaceTemp[i].currentOccupancy &&
            rowDataSpaceTemp[i].currentOccupancy != ""
              ? rowDataSpaceTemp[i].currentOccupancy
              : "EMPTY",
        });
      }
      setRowDataSpace(data);
    }
  }, [rowDataSpaceTemp]);

  useEffect(() => {
    if (rowDataDoorLogTemp?.length > 0) {
      var sortedDoorLog = rowDataDoorLogTemp.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      if (door != "") {
        let spaceOccupant =
          sortedDoorLog[0].currOccupancy && sortedDoorLog[0].currOccupancy.btId
            ? sortedDoorLog[0].currOccupancy.btId
            : "EMPTY";
        setSpaceOccupant(spaceOccupant);
      }
    }
  }, [rowDataDoorLogTemp]);

  useEffect(() => {
    if (rowDataTrailer && rowDataTrailer.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataTrailer.length; i++) {
        data.push({
          label: rowDataTrailer[i].btId,
          value: rowDataTrailer[i].id,
          location: rowDataTrailer[i].currentLocation,
        });
      }
      setTrailerIdArray(data);
    }
  }, [rowDataTrailer && rowDataTrailer.length > 0]);

  useEffect(() => {
    if (lot != "" && lot != null) {
      let lotTempArray = rowDataLot?.filter(
        (item) => item.lotName == lot.lotName
      );
      let spaceArray = lotTempArray[0]?.space;

      if (spaceArray && spaceArray.length > 0) {
        var data = [];
        for (var i = 0; i < spaceArray.length; i++) {
          let btId =
            spaceArray[i]?.btId && spaceArray[i].btId ? spaceArray[i].btId : "";

          data.push({
            label: division.value + "_" + lotTempArray[0].lotName + "-" + btId,
            value: btId,
          });
        }
        setSpaceArray(data);
      }
    }
  }, [rowDataLot]);

  useEffect(() => {
    if (addCorrectionLogResponse?.toLowerCase() == "success") {
      setDivision("");
      setDoor("");
      setsystemLocation("");
      setSpaceOccupant("");
      setChooseLot("");
      setChooseTrailer("");
      setSpace("");
      setLocation("");
    }
  }, [addCorrectionLogResponse]);

  useEffect(() => {
    if (rowDataLocation.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataLocation.length; i++) {
        data.push({
          label: rowDataLocation[i].name,
          value: rowDataLocation[i].location_id,
        });
      }
      setLocationArray(data);
    }
  }, [rowDataLocation]);

  //correct space id
  useEffect(() => {
    if (rowDataSpaceLogTemp.length > 0) {
      var sortedSpaceLog = rowDataSpaceLogTemp.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      if (space != "" && sortedSpaceLog.length > 0) {
        let spaceOccupant = sortedSpaceLog[0].currOccupancy?.btId
          ? sortedSpaceLog[0].currOccupancy.btId
          : "EMPTY";
        let spaceId = sortedSpaceLog[0]?.space_id
          ? sortedSpaceLog[0].space_id
          : null;
        setCorrectSpaceId(spaceId);
        setSpaceOccupant(spaceOccupant);
      } else {
        setSpaceOccupant("EMPTY");
      }
    } else {
      setSpaceOccupant("EMPTY");
    }
  }, [rowDataSpaceLogTemp]);

  useEffect(() => {
    if (rowDataCorrectionLog?.length > 0) {
      setCorrectionLogData(rowDataCorrectionLog);
    }
  }, [rowDataCorrectionLog]);

  //incorrect door / space
  useEffect(() => {
    if (rowDataRuralLog.length > 0) {
      var sortedDoorLog = rowDataRuralLog.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      if (sortedDoorLog.length > 0) {
        let spaceOccupant = sortedDoorLog[0].currDoor?.door_id
          ? sortedDoorLog[0].currDoor.doorType +
            "_" +
            sortedDoorLog[0].currDoor.number
          : sortedDoorLog[0]?.currSpace && sortedDoorLog[0].currSpace.btId
          ? sortedDoorLog[0].currSpace.lot?.lotName +
            "_" +
            sortedDoorLog[0].currSpace.btId
          : sortedDoorLog[0]?.currentLocation
          ? sortedDoorLog[0].currentLocation
          : "UNKNOWN";
        setsystemLocation(
          (division?.label ? division.label + "_" : "") + spaceOccupant
        );

        let doorId = sortedDoorLog[0].currDoor?.door_id
          ? sortedDoorLog[0].currDoor.door_id
          : null;
        setInCorrectDoorId(doorId);

        let spaceId =
          sortedDoorLog[0]?.currSpace && sortedDoorLog[0].currSpace.space_id
            ? sortedDoorLog[0].currSpace.space_id
            : null;
        setInCorrectSpaceId(spaceId);
      } else {
        setsystemLocation("Unknown");
      }
    } else {
      setsystemLocation("Unknown");
    }
  }, [rowDataRuralLog]);

  const formatAMPM = (date) => {
    // This is to display 12 hour format like you asked
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  const [columnDefsLog] = useState([
    {
      headerName: "Date",
      name: "Created At",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let myDate = params?.createdAt
          ? new Date(params.createdAt)
          : new Date();
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },
    {
      headerName: "Designation Location",
      name: "Designation Location",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let designationLocation =
          params?.trailer != null
            ? params.trailer.designationLocation
            : "EMPTY";
        return designationLocation;
      },
    },
    {
      headerName: "Load",
      name: "Current Load",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let preOccupancy =
          params?.preOccupancy != null ? params.preOccupancy : "EMPTY";
        return preOccupancy;
      },
    },
    {
      headerName: "Condition",
      name: "Condition",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let condition =
          params?.trailer != null
            ? params?.trailer?.condition
              ? params.trailer.condition
              : ""
            : "---";
        return condition;
      },
    },
    {
      headerName: "Status",
      name: "Status",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let Status =
          params?.trailer != null
            ? params?.trailer?.status
              ? params.trailer.status
              : ""
            : "EMPTY";
        return Status;
      },
    },
    {
      headerName: "Location",
      name: "Location",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let Location =
          params?.trailer != null
            ? params?.trailer.previousLocation +
              "--->" +
              params?.trailer.currentLocation
            : "EMPTY";
        return Location;
      },
    },
  ]);

  const dispatch = useDispatch();

  const [spaceOccupant, setSpaceOccupant] = useState("EMPTY");

  const handlePageChange = (pageNo) => {
    let obj = {
      pageSize: pageNo,
      limit: pageLimit,
    };
    dispatch({
      type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT
        .GET_CORRECTION_LOG_API_CALL,
      payload: { value: obj },
    });
    setCurrentPage(pageNo);
  };

  const handlePerRowsChange = async (newPerPage, pageNo) => {
    let obj = {
      pageSize: pageNo,
      limit: newPerPage,
    };
    dispatch({
      type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT
        .GET_CORRECTION_LOG_API_CALL,
      payload: { value: obj },
    });
  };

  return (
    <div className="row">
      <div className="col-md-12 col-sm-12 col-12">
        {/* //Add trailer */}

        <div className="col-md-12 col-sm-12 row-4 me-12">
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-lg-3 mb-2" />

            <div
              onClick={() => {
                setNewCorrectionClick(true);
                setShowCorrectionLog(false);
              }}
              className="col-12 col-md-5 col-sm-12 col-lg-2 mb-2"
              style={{ backgroundColor: "red", borderRadius: 4 }}
            >
              <label
                style={{
                  fontSize: "0.8em",
                  color: "white",
                  textAlign: "center",
                }}
              >
                {"New Correction"}
              </label>
            </div>

            <div
              onClick={() => {
                setNewCorrectionClick(false);
                setShowCorrectionLog(true);
                let obj = {
                  pageSize: pageNo,
                  limit: pageLimit,
                };
                dispatch({
                  type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT
                    .GET_CORRECTION_LOG_API_CALL,
                  payload: { value: obj },
                });
              }}
              className="col-12 col-md-5 col-sm-12 col-lg-2 mb-2"
              style={{ backgroundColor: "#00A0B0", borderRadius: 4 }}
            >
              <label
                style={{
                  fontSize: "0.8em",
                  color: "white",
                  textAlign: "center",
                }}
              >
                {"Show Correction Logs"}
              </label>
            </div>

            <div className="col-lg-3 mb-2" />
          </div>
        </div>

        {newCorrectionClick ? (
          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-5"
            style={{
              height: "80vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <div
              className="row col-md-12 col-sm-12 col-lg-12 row-10"
              style={{
                height: "6vh",
                width: "80vw",
                backgroundColor: "darkGray",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label style={{ fontSize: "1.2em", color: "white" }}>
                {"New Correction"}
              </label>
            </div>

            <div
              className="row col-md-12 col-sm-12  col-lg-12 row-10 ag-theme-alpine"
              style={{
                height: "auto",
                width: "80vw",
                borderRadius: "5",
                borderColor: "black",
                padding: 10,
                backgroundColor: "white",
              }}
            >
              <div
                className="row col-md-12 col-sm-12  col-lg-12 "
                style={{
                  height: "10vh",
                  width: "100vw",
                  borderRadius: "5",
                  borderColor: "black",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <div
                  onClick={() => {
                    setCurrentLocation(true);
                    setCustomPlaceTrailer(false);
                    setChooseTrailer("");
                    setsystemLocation("");
                  }}
                  className="col-12 col-md-5 col-sm-12 col-lg-3 "
                  style={{
                    height: "5vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "red",
                    borderRadius: 4,
                  }}
                >
                  <label
                    style={{
                      fontSize: "0.9em",
                      color: "white",
                      textAlign: "center",
                      margin: 0,
                    }}
                  >
                    {"Remove Trailer from Current Location"}
                  </label>
                </div>

                <div
                  onClick={() => {
                    setCurrentLocation(false);
                    setCustomPlaceTrailer(true);
                    setChooseTrailer("");
                    setsystemLocation("");
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
                        .GET_LOCATION_API_CALL,
                      payload: { value: { bydivision: true } },
                    });
                  }}
                  className="col-12 col-md-5 col-sm-12 col-lg-2 mb-2 mt-2"
                  style={{
                    height: "5vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#00A0B0",
                    borderRadius: 4,
                  }}
                >
                  <label
                    style={{
                      fontSize: "0.9em",
                      color: "white",
                      textAlign: "center",
                      margin: 0,
                    }}
                  >
                    {"Custom Place a trailer"}
                  </label>
                </div>
              </div>

              <div
                className="row col-md-12 col-sm-12  col-lg-12 mt-3"
                style={{
                  height: "auto",
                  width: "100vw",
                  borderRadius: "5",
                  borderColor: "black",
                }}
              >
                <label style={{ fontSize: "1.2em", marginRight: 12 }}>
                  {" "}
                  {currentLocation
                    ? `Remove Incorrect Trailer's Current Location`
                    : `Manual Trailer's Management`}
                </label>

                {currentLocation ? (
                  <div className="container ">
                    <div className="row container d-flex f-direction-row mt-3">
                      <div className="col-12 col-sm-4 col-md-4 col-4">
                        <label style={{ fontSize: "1.2em", marginRight: 12 }}>
                          Choose Trailer:
                        </label>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6 col-6">
                        <DropDownComp
                          styles={{
                            display: "flex",
                            flexDirection: "row",
                            fontSize: 14,

                            height: 35,
                            padding: 2,
                            borderColor: "hsl(0, 0%, 50%)",
                            borderRadius: "4px",
                            borderStyle: "solid",
                            borderWidth: "1px",
                          }}
                          name={"Choose Trailer"}
                          options={trailerIdArray}
                          onChange={(value) => {
                            setChooseTrailer(value);
                            let obj = {
                              id: value.value,
                            };
                            dispatch({
                              type: CONSTANTS
                                .CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                                .GET_RURAL_TRAILER_LOGS_API_CALL,
                              payload: { value: obj },
                            });
                          }}
                          value={chooseTrailer}
                        />
                      </div>
                    </div>

                    <div className="row container d-flex f-direction-row ">
                      <div className="col-12 col-sm-4 col-md-4 col-4">
                        <label style={{ fontSize: "1.2em", marginRight: 12 }}>
                          Trailer System Location
                        </label>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6 col-6">
                        <InputComp
                          style={{
                            display: "flex",
                            flexDirection: "row",

                            width: "100%",
                            height: 35,
                            borderColor: "hsl(0, 0%, 50%)",
                            borderRadius: "4px",
                            borderStyle: "solid",
                            borderWidth: "1px",
                            paddingLeft: 14,
                            fontSize: 14,
                          }}
                          labelName={"Trailer System Location"}
                          maxLength={30}
                          placeholder={"Trailer System Location"}
                          value={systemLocation}
                          onChangeHandler={(systemLocation) => {
                            setsystemLocation(systemLocation);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="container ">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <label className="ml-10" style={{ fontSize: 14 }}>
                        <input
                          type="radio"
                          checked={doorRadio}
                          onClick={() => {
                            setDoorRadio(true);
                            setSpaceRadio(false);
                            setOffSiteRadio(false);
                            setsystemLocation("");

                            setDivision("");
                            setDoor("");
                            setSpace("");
                            setChooseLot("");
                            setLocation("");
                            setChooseTrailer("");
                          }}
                          value="Door"
                        />
                        Door
                      </label>

                      <label style={{ fontSize: 14 }}>
                        <input
                          type="radio"
                          checked={spaceRadio}
                          onClick={() => {
                            setDoorRadio(false);
                            setSpaceRadio(true);
                            setOffSiteRadio(false);
                            setsystemLocation("");
                            setDivision("");
                            setDoor("");
                            setSpace("");
                            setChooseLot("");
                            setLocation("");
                            setChooseTrailer("");

                            dispatch({
                              type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                                .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
                            });
                          }}
                          value="Space"
                        />{" "}
                        Space
                      </label>

                      <label style={{ fontSize: 14 }}>
                        <input
                          type="radio"
                          checked={Offsite}
                          onClick={() => {
                            setDoorRadio(false);
                            setSpaceRadio(false);
                            setOffSiteRadio(true);
                            setsystemLocation("");

                            setDivision("");
                            setDoor("");
                            setSpace("");
                            setChooseLot("");
                            setChooseTrailer("");

                            dispatch({
                              type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
                                .GET_LOCATION_API_CALL,
                              payload: { value: { bydivision: true } },
                            });
                          }}
                          value="OffSite"
                        />{" "}
                        OffSite
                      </label>
                    </div>

                    {spaceRadio ? (
                      <div>
                        <div className="row container d-flex f-direction-row mt-3">
                          <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                            <label
                              style={{ fontSize: "1.2em", marginRight: 12 }}
                            >
                              Choose Division
                            </label>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                            <DropDownComp
                              styles={{
                                display: "flex",
                                flexDirection: "row",
                                fontSize: 14,

                                width: "100%",
                                height: 35,
                                padding: 2,
                                borderColor: "hsl(0, 0%, 50%)",
                                borderRadius: "4px",
                                borderStyle: "solid",
                                borderWidth: "1px",
                              }}
                              name={"Choose Division"}
                              options={divisionArr}
                              onChange={(value) => {
                                setDivision(value);
                                setDoor("");
                                setChooseLot("");
                                setSpace("");
                                setLotArray([]);

                                let lotTempArray = rowDataLot?.filter(
                                  (item) => item.division_id == value.value
                                );
                                if (lotTempArray && lotTempArray.length > 0) {
                                  var data = [];
                                  for (
                                    var i = 0;
                                    i < lotTempArray.length;
                                    i++
                                  ) {
                                    if (lotTempArray[i]?.is_active === 1) {
                                      data.push({
                                        label: lotTempArray[i].lotName,
                                        value: lotTempArray[i].lot_id,
                                      });
                                    }
                                  }

                                  setLotArray(data);
                                }
                              }}
                              value={division}
                            />
                          </div>
                        </div>

                        {division != null && division != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Choose Lot:
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                              <DropDownComp
                                styles={{
                                  display: "flex",
                                  flexDirection: "row",
                                  fontSize: 14,

                                  height: 35,
                                  padding: 2,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                }}
                                name={"Choose Lot"}
                                options={lotDataArray}
                                onChange={(lotValue) => {
                                  let obj = {
                                    lot_id: lotValue.value,
                                  };

                                  dispatch({
                                    type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                                      .GET_SPACES_BY_LOTID_MANAGEMENT_API_CALL,
                                    payload: { value: obj },
                                  });
                                  setChooseLot(lotValue);
                                  setSpace("");
                                }}
                                value={lot}
                                //&& props.rowData != 'null' ? props.rowData.Status : 'Active'
                              />
                            </div>
                          </div>
                        ) : null}

                        {lot != null && lot != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Choose Space
                              </label>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                              <DropDownComp
                                styles={{
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100%",
                                  fontSize: 14,

                                  height: 35,
                                  padding: 2,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                }}
                                name={"Choose Space"}
                                options={rowDataSpace}
                                onChange={(value) => {
                                  setSpace(value);
                                  let obj = {
                                    space_id: value.value,
                                  };
                                  dispatch({
                                    type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                                      .GET_SPACELOGS_MANAGEMENT_API_CALL,
                                    payload: { value: obj },
                                  });
                                }}
                                value={space}
                              />
                            </div>
                          </div>
                        ) : null}

                        {space != null && space != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                System Space Occupant
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                              <InputComp
                                style={{
                                  display: "flex",
                                  flexDirection: "row",

                                  width: "100%",
                                  height: 35,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  paddingLeft: 14,
                                  fontSize: 14,
                                }}
                                labelName={"System Space Occupant"}
                                maxLength={30}
                                placeholder={"System Space Occupant"}
                                value={spaceOccupant}
                                onChangeHandler={(spaceOccupant) => {}}
                              />
                            </div>
                          </div>
                        ) : null}

                        {space != null && space != "" ? (
                          <div className="row container d-flex f-direction-row mt-3">
                            <div className="col-12 col-sm-4 col-md-4 col-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Choose Trailer:
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-6">
                              <DropDownComp
                                styles={{
                                  display: "flex",
                                  flexDirection: "row",
                                  fontSize: 14,

                                  height: 35,
                                  padding: 2,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                }}
                                name={"Choose Trailer"}
                                placeholder={"CHOOSE TRAILER"}
                                options={trailerIdArray}
                                onChange={(value) => {
                                  if (spaceOccupant != value?.label) {
                                    setChooseTrailer(value);
                                    let obj = {
                                      id: value.value,
                                    };
                                    dispatch({
                                      type: CONSTANTS
                                        .CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                                        .GET_RURAL_TRAILER_LOGS_API_CALL,
                                      payload: { value: obj },
                                    });
                                  } else {
                                    alert(
                                      "Trailer already place in space ,choose another trailer"
                                    );
                                  }
                                }}
                                value={chooseTrailer}
                                //&& props.rowData != 'null' ? props.rowData.Status : 'Active'
                              />
                            </div>
                          </div>
                        ) : null}

                        {chooseTrailer != null && chooseTrailer != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Trailer System Location
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-6">
                              <InputComp
                                style={{
                                  display: "flex",
                                  flexDirection: "row",

                                  width: "100%",
                                  height: 35,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  paddingLeft: 14,
                                  fontSize: 14,
                                }}
                                labelName={"Trailer System Location"}
                                isDisabled={true}
                                placeholder={"Trailer System Location"}
                                value={systemLocation}
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : doorRadio ? (
                      <div>
                        <div className="row container d-flex f-direction-row mt-3">
                          <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                            <label
                              style={{ fontSize: "1.2em", marginRight: 12 }}
                            >
                              Choose Division
                            </label>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                            <DropDownComp
                              styles={{
                                display: "flex",
                                flexDirection: "row",
                                fontSize: 14,

                                width: "100%",
                                height: 35,
                                padding: 2,
                                borderColor: "hsl(0, 0%, 50%)",
                                borderRadius: "4px",
                                borderStyle: "solid",
                                borderWidth: "1px",
                              }}
                              name={"Choose Division"}
                              options={divisionArr}
                              onChange={(value) => {
                                setDivision(value);
                                setDoor("");
                                setChooseLot("");

                                let divisionData = rowDataDoor.filter(
                                  (item) =>
                                    item.division_id == value.division_id
                                );

                                if (divisionData && divisionData.length > 0) {
                                  var data = [];
                                  for (
                                    var i = 0;
                                    i < divisionData.length;
                                    i++
                                  ) {
                                    data.push({
                                      label:
                                        value.label +
                                        "_" +
                                        divisionData[i].doorType +
                                        "_" +
                                        divisionData[i].number,
                                      value: divisionData[i].door_id,
                                      currentOccupancy:
                                        divisionData[i].currentOccupancy,
                                    });
                                  }
                                  setDoorDataArr(data);
                                } else {
                                  setDoorDataArr([]);
                                }
                              }}
                              value={division}
                              //&& props.rowData != 'null' ? props.rowData.Status : 'Active'
                            />
                          </div>
                        </div>

                        {division != null && division != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Choose Door:
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                              <DropDownComp
                                styles={{
                                  display: "flex",
                                  flexDirection: "row",
                                  fontSize: 14,

                                  height: 35,
                                  padding: 2,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                }}
                                name={"Choose Door"}
                                options={doorDataArr}
                                onChange={(value) => {
                                  setDoor(value);
                                  let obj = {
                                    door_id: value.value,
                                  };
                                  dispatch({
                                    type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT
                                      .GET_DOORS_LOG_MANAGEMENT_API_CALL,
                                    payload: { value: obj },
                                  });
                                }}
                                value={door}
                              />
                            </div>
                          </div>
                        ) : null}

                        {door != null && door != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                System Door Occupant
                              </label>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                              <InputComp
                                style={{
                                  display: "flex",
                                  flexDirection: "row",

                                  width: "100%",
                                  height: 35,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  paddingLeft: 14,
                                  fontSize: 14,
                                }}
                                labelName={"System Space Occupant"}
                                maxLength={30}
                                placeholder={"System Space Occupant"}
                                value={spaceOccupant}
                                onChangeHandler={(spaceOccupant) => {
                                  setSpaceOccupant(spaceOccupant);
                                }}
                              />
                            </div>
                          </div>
                        ) : null}

                        {door != null && door != "" ? (
                          <div className="row container d-flex f-direction-row mt-3">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Choose Trailer
                              </label>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                              <DropDownComp
                                styles={{
                                  display: "flex",
                                  flexDirection: "row",
                                  fontSize: 14,

                                  width: "100%",
                                  height: 35,
                                  padding: 2,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                }}
                                name={"Choose Trailer"}
                                options={trailerIdArray}
                                onChange={(value) => {
                                  if (spaceOccupant != value.label) {
                                    setChooseTrailer(value);
                                    let obj = {
                                      id: value?.value,
                                    };
                                    dispatch({
                                      type: CONSTANTS
                                        .CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                                        .GET_RURAL_TRAILER_LOGS_API_CALL,
                                      payload: { value: obj },
                                    });
                                  } else {
                                    alert(
                                      "Trailer already place in space ,choose another trailer"
                                    );
                                  }
                                }}
                                value={chooseTrailer}
                              />
                            </div>
                          </div>
                        ) : null}

                        {door != null && door != "" && chooseTrailer != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Trailer System Location
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-6">
                              <InputComp
                                style={{
                                  display: "flex",
                                  flexDirection: "row",

                                  width: "100%",
                                  height: 35,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  paddingLeft: 14,
                                  fontSize: 14,
                                }}
                                labelName={"Trailer System Location"}
                                maxLength={30}
                                isDisabled={true}
                                placeholder={"Trailer System Location"}
                                value={systemLocation}
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : Offsite ? (
                      <div>
                        <div className="row container d-flex f-direction-row mt-3">
                          <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                            <label
                              style={{ fontSize: "1.2em", marginRight: 12 }}
                            >
                              Choose OffSite Location
                            </label>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                            <DropDownComp
                              styles={{
                                display: "flex",
                                flexDirection: "row",
                                fontSize: 14,

                                width: "100%",
                                height: 35,
                                padding: 2,
                                borderColor: "hsl(0, 0%, 50%)",
                                borderRadius: "4px",
                                borderStyle: "solid",
                                borderWidth: "1px",
                              }}
                              name={"Choose Location"}
                              options={locationArr}
                              onChange={(value) => {
                                setLocation(value);
                                setDoor("");
                                setDivision("");
                                setChooseLot("");
                              }}
                              value={location}
                              //&& props.rowData != 'null' ? props.rowData.Status : 'Active'
                            />
                          </div>
                        </div>

                        <div className="row container d-flex f-direction-row mt-3">
                          <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                            <label
                              style={{ fontSize: "1.2em", marginRight: 12 }}
                            >
                              Choose Trailer
                            </label>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                            <DropDownComp
                              styles={{
                                display: "flex",
                                flexDirection: "row",
                                fontSize: 14,

                                width: "100%",
                                height: 35,
                                padding: 2,
                                borderColor: "hsl(0, 0%, 50%)",
                                borderRadius: "4px",
                                borderStyle: "solid",
                                borderWidth: "1px",
                              }}
                              name={"Choose Trailer"}
                              options={trailerIdArray}
                              onChange={(value) => {
                                if (spaceOccupant != value?.label) {
                                  setChooseTrailer(value);
                                  let obj = {
                                    id: value?.value,
                                  };
                                  dispatch({
                                    type: CONSTANTS
                                      .CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                                      .GET_RURAL_TRAILER_LOGS_API_CALL,
                                    payload: { value: obj },
                                  });
                                } else {
                                  alert(
                                    "Trailer already place in space ,choose another trailer"
                                  );
                                }
                              }}
                              value={chooseTrailer}
                            />
                          </div>
                        </div>
                        {chooseTrailer != null && chooseTrailer != "" ? (
                          <div className="row container d-flex f-direction-row ">
                            <div className="col-12 col-sm-4 col-md-4 col-4">
                              <label
                                style={{ fontSize: "1.2em", marginRight: 12 }}
                              >
                                Trailer System Location
                              </label>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-6">
                              <InputComp
                                style={{
                                  display: "flex",
                                  flexDirection: "row",

                                  width: "100%",
                                  height: 35,
                                  borderColor: "hsl(0, 0%, 50%)",
                                  borderRadius: "4px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  paddingLeft: 14,
                                  fontSize: 14,
                                }}
                                labelName={"Trailer System Location"}
                                maxLength={30}
                                isDisabled={true}
                                placeholder={"Trailer System Location"}
                                value={systemLocation}
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                )}

                <div
                  onClick={() => {
                    if (currentLocation) {
                      setCurrentLocation(true);
                      setCustomPlaceTrailer(false);
                    } else {
                      setCurrentLocation(false);
                      setCustomPlaceTrailer(true);
                    }
                    let correctionPayload = {
                      user_id: userId,
                      trailer_id: chooseTrailer?.value || null,
                      incorrect_door_id: incoorrect_door_id,
                      correct_door_id: door?.value || null,
                      incorrect_space_id: incoorrect_space_id,
                      correct_space_id: space?.value || null,
                      newLocation_id: location?.value || null,
                    };

                    dispatch({
                      type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT
                        .ADD_COORECTION_API_CALL_SUCCESS,
                      payload: { value: "" },
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT
                        .ADD_COORECTION_API_CALL,
                      payload: { value: correctionPayload },
                    });
                  }}
                  className="col-12 col-md-12 col-sm-12 col-lg-12 mt-3"
                  style={{
                    height: "5vh",
                    width: "30%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    alignSelf: "center",
                    backgroundColor: "#F6BE00",
                    borderRadius: 4,
                    margin: "auto",
                  }}
                >
                  <label
                    style={{
                      fontSize: "0.9em",
                      color: "white",
                      textAlign: "center",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {currentLocation
                      ? "Remove Trailer from current Location"
                      : doorRadio
                      ? " Place Trailer in Door"
                      : spaceRadio
                      ? "Place Trailer in Space"
                      : "Place Trailer in OffSite"}
                  </label>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="col-12 col-lg-12 col-md-12 col-sm-12 ag-theme-alpine"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "80vh",
              width: "80vw",
              justifyContent: "space-between",
            }}
          >
            <div
              className="col-md-12 col-sm-12 ag-theme-alpine"
              style={{
                height: "80vh",
                width: "80vw",
                margin: "auto",
              }}
            >
              <DataTable
                ref={gridRef}
                getRowClassName={(params) =>
                  `super-app-theme--${params.row.status}`
                }
                columns={columnDefsLog}
                data={correctionLodData}
                responsive={true}
                pagination
                paginationServer
                paginationTotalRows={rowDataCorrectionLogCount}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                selectableRows
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CorrectionComp;
